export default name => {
  if (typeof mboxCreate === "function") {
    mboxCreate(name);
  }
};




// WEBPACK FOOTER //
// ./js/analytics/target.js